/* eslint-disable no-script-url */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import actions from 'actions';
import { getPossibleSlug } from 'utils/slug';
import './styles.scss';

const POI_SEARCH_INTERVAL_MS = 50;
const SLUG_SEARCH_DELAY_MS = 50;
const POI_INFORMATION_CLOSE_SELECTOR = '.gm-style-iw button.gm-ui-hover-effect';

const closePoiInformation = () => {
  const closeButton = document.querySelector(POI_INFORMATION_CLOSE_SELECTOR);

  if (closeButton) {
    closeButton.click();
  }
};

class SpotForm extends Component {
  state = {
    // Real form
    name: this.props.name || '',
    from: this.props.from || '',
    slug: this.props.slug || '',
    city: this.props.city || '',
    country: this.props.country || '',

    // Spot found with the new slug
    spotWithSameSlug: null,

    isSearching: false,
  };

  searchForPoiInterval = null;
  geocodingRequestId = 0;

  async componentDidMount() {
    const slug = this.getNewSlug(this.state);

    this.setState({ slug }, () => {
      this._checkIfSlugExists(slug);
      this.onChange();
    });

    this.searchForPoiInterval = setInterval(this.getDataFromPoI, POI_SEARCH_INTERVAL_MS);

    this.loadPlace();

    if (this.props.poi && this.props.poi.name) {
      this.getDataFromPoI(this.props.poi.name);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.poi !== prevProps.poi && this.props.poi && this.props.poi.name) {
      this.getDataFromPoI(this.props.poi.name);
    }

    if (this.props.lat !== prevProps.lat || this.props.lng !== prevProps.lng) {
      this.loadPlace();
    }
  }

  componentWillUnmount() {
    clearInterval(this.searchForPoiInterval);
    this.geocodingRequestId++;
  }

  loadPlace = () => {
    const lat = Number(this.props.lat);
    const lng = Number(this.props.lng);

    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
      return;
    }

    const requestId = ++this.geocodingRequestId;

    actions.google
      .getPlace(lat, lng)
      .then(({ country, city }) => {
        if (requestId !== this.geocodingRequestId) {
          return;
        }

        this.setState(previousState => {
          const newState = {
            city: previousState.city || city || '',
            country: previousState.country || country || '',
          };
          const slug = this.getNewSlug({ ...previousState, ...newState });

          return { ...newState, slug };
        }, () => {
          this._checkIfSlugExists(this.state.slug);
          this.onChange();
        });
      })
      .catch(error => {
        if (requestId === this.geocodingRequestId) {
          console.error('Unable to get city and country', error);
        }
      });
  };

  UNSAFE_componentWillReceiveProps({ name, from, slug, city, country }) {
    let isNewData = false;

    const newState = {};

    if (name !== this.state.name) {
      newState.name = name;
      isNewData = true;
    }

    if (from !== this.state.from) {
      newState.from = from;
      isNewData = true;
    }

    if (slug !== this.state.slug) {
      newState.slug = slug;
      isNewData = true;
    }

    if (city !== this.state.city) {
      newState.city = city;
      isNewData = true;
    }

    if (country !== this.state.country) {
      newState.country = country;
      isNewData = true;
    }

    if (isNewData) {
      this.setState(newState);
    }
  }

  getDataFromPoI = poiName => {
    const { name, from } = this.state;

    // If all done, return
    if (name && from) {
      clearInterval(this.searchForPoiInterval);
      return;
    }

    const titleElement = document.querySelector('.Map .gm-title');

    if (!poiName && (!titleElement || !titleElement.innerText)) {
      return;
    }

    const title = (poiName || titleElement.innerText).trim();

    // The title was already set in some of the values
    if (title === name || title === from) {
      return;
    }

    const newState = {};

    if (!name) {
      newState.name = title;
    } else if (!from) {
      newState.from = title;
    }

    if (Object.keys(newState).length === 0) {
      return;
    }

    newState.slug = this.getNewSlug({ ...this.state, ...newState });

    this.setState(newState, () => {
      this._checkIfSlugExists(newState.slug);
      this.onChange();

      closePoiInformation();
      document.querySelector('.Moderation button.approve').focus();
    });
  };

  _onInputChange = ({ target: { name, value } }) => {
    if (name === 'slug') {
      if (value) {
        this._checkIfSlugExists(value);
      } else {
        this.setState({ spotWithSameSlug: null });
      }
    }

    if (name === 'slug') {
      this.setState({ [name]: value }, this.onChange);
    } else {
      const slug = this.getNewSlug({ ...this.state, [name]: value });

      this.setState({ [name]: value, slug }, () => {
        this._checkIfSlugExists(slug);
        this.onChange();
      });
    }
  };

  getNewSlug = ({ name, from, city, country }) => {
    const slug = getPossibleSlug(name, from, city, country);

    return slug;
  };

  onChange = () => {
    const { name, from, slug, city, country } = this.state;
    this.props.onChange({ name, from, slug, city, country });
  };

  checkTimeout = null;
  _checkIfSlugExists = slug => {
    clearTimeout(this.checkTimeout);

    if (!this.state.isSearching) {
      this.setState({ isSearching: true });
    }

    this.checkTimeout = setTimeout(() => {
      const spotWithSameSlug = this.props.spots.find(x => x.slug === slug);
      this.setState({ spotWithSameSlug, isSearching: false });
    }, SLUG_SEARCH_DELAY_MS);
  };

  handleSubmit = e => {
    e.preventDefault();

    if (this.state.isSearching) {
      window.alert('Still searching for slugs... tranquilo!');
      return;
    }

    if (this.props.onSubmit) {
      this.props.onSubmit();
    }
  };

  render() {
    return (
      <div className="SpotForm">
        <form onSubmit={this.handleSubmit}>
          <input
            autoFocus={!this.state.name}
            type="text"
            className="name"
            placeholder="Spot name"
            name="name"
            value={this.state.name}
            onChange={this._onInputChange}
          />

          <input
            autoFocus={!!this.state.name && !this.state.from}
            type="text"
            className="from"
            placeholder="From"
            name="from"
            value={this.state.from}
            onChange={this._onInputChange}
          />

          <input
            type="text"
            className="city"
            placeholder="City"
            name="city"
            value={this.state.city}
            onChange={this._onInputChange}
          />

          <input
            type="text"
            className="country"
            placeholder="Country"
            name="country"
            value={this.state.country}
            onChange={this._onInputChange}
          />

          <input
            type="text"
            className="slug"
            placeholder="Slug"
            name="slug"
            value={this.state.slug}
            onChange={this._onInputChange}
          />

          <input className="submit" type="submit" disabled={this.state.isSearching} />

          {this.state.isSearching && <span>Searching...</span>}
          {this.state.spotWithSameSlug && (
            <h3 style={{ color: 'red' }}>THERE IS AN SPOT WITH THIS SLUG!</h3>
          )}
        </form>
      </div>
    );
  }
}

SpotForm.propTypes = {
  name: PropTypes.string,
  from: PropTypes.string,
  country: PropTypes.string,
  city: PropTypes.string,
  poi: PropTypes.shape({
    name: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
};

export default SpotForm;
